import { createFileRoute } from "@tanstack/react-router";

import { NewsletterRelease } from "@/features/newsletter/modules/newsletter-release/newsletter-release";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/newsletter/$releaseId/")({
  component: RouteComponent,
  loader: () => ({ crumb: m.newsletter_release_crumb_public() }),
});

function RouteComponent() {
  const { releaseId } = Route.useParams();
  return <NewsletterRelease releaseId={releaseId} />;
}
